import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    drawer: true,
    rail: true,
    scroll: false,
    logged: false,
    largeScreen: true,
    alertMessage: '',
    color: 'error',
    timeout: 6000,
  }),
  actions: {
    raiseAlert(message, color = 'error') {
      this.alertMessage = message;
      this.color = color;
    },
    clearAlert() {
      this.alertMessage = '';
    },
  },
});
